import {
    GET_ALL_CS,
    GET_CS,
    CACS_LOADING,
    ADD_CS,
    GET_POSITION,
    GET_USERS_FILE,
    GET_FILTER
  } from "../actions/ExtracurricularCoursesAdminCouseScheduleAction";
  
  
  const initialState = {
    CouseSchedulelist: [],
    CouseSchedule: [],
    Positionlist: [],
    Filterlist: [],
    UserFiles:[],
    loading: false,
    add: false,
  };
  
  const UserAdmin = function(state = initialState, action) {
    switch (action.type) {
        case CACS_LOADING: {
          return {
            ...state,
            loading: true,
            add: false
          };
        }
        case GET_ALL_CS: {
            return{
                ...state,
                CouseSchedulelist : [...action.data],
                CouseSchedule:[],
                loading: false,
                add : false,
            }
        }
        case GET_CS: {
          return{
              ...state,
              CouseSchedule : [...action.data],
              loading: false
          }
        }
        case GET_POSITION: {
          return{
              ...state,
              Positionlist : [...action.data],
              loading: false
          }
        }
        case GET_FILTER: {
          return{
              ...state,
              Filterlist : [...action.data],
              loading: false
          }
        }
        case GET_USERS_FILE: {
          return{
              ...state,
              UserFiles : [...action.data],
              loading: false
          }
        }
        case ADD_CS: {
          return {
            ...state,
            CouseSchedule:[],
            add : true,
            loading: false  
          };
        }
        default: {
            return state;
          }
        }
  }
  
  export default UserAdmin;
  